import axios from "axios";
import { IImages } from "./decodeAndFetchImages";
import { getUser } from "api/axios";
import { blobToBase64 } from "./blobToBase64";

export const removeHtml = (content: string) => {
  if (!content) return content;
  const regex = /(<([^>]+)>)/gi;
  const newString = content.replace(regex, "");

  return newString;
};

export const removeImages = (html: string): string => {
  return html.replace(/<img[^>]*>/gi, "");
};
// TODO DOdać sprawdzanie czy istnieją obrazki jeżeli tak pobrać je i pewnie deszyfrować

export const fetchImage = async (url: string) => {
  const user = getUser();
  const token = user?.access_token;

  const blob = await axios.get(url, {
    responseType: "blob",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return blob.data;
};

export const hasImages = async (content: string) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(content, "text/html");
  const images = doc.getElementsByTagName("img");

  return !!images.length;
};

export const addToUrl = async (content: string, allowImages = false) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(content, "text/html");
  const images = doc.getElementsByTagName("img");

  // Usuń style z elementu body
  // const allElements = doc.querySelectorAll('body *');
  // allElements.forEach((element) => {
  //   element.removeAttribute('style');
  // });

  // const headElement = doc.querySelector('head');
  // if (headElement) {
  //   const htmlElement = doc.querySelector('html');
  //   htmlElement?.removeChild?.(headElement);
  // }

  for (let i = 0; i < images.length; i++) {
    // Pobierz aktualny obiekt img
    const img = images[i];
    if (img.hasAttribute("src")) {
      if (!allowImages) {
        //@ts-ignore
        img.setAttribute("src", "");
        continue;
      }
      const url = img.getAttribute("src");
      const link = `https://beta.pocztaprawnicza.pl${url}`;

      const image = await fetchImage(link);
      const base64 = await blobToBase64(image);
      //@ts-ignore
      img.setAttribute("src", base64);
    }
  }

  // Pobierz zmodyfikowany HTML
  const modifiedHTML = doc.documentElement.outerHTML;

  return modifiedHTML;
};

export interface IParsedHtml {
  content: string;
  // czy zawiera historię, którą można wzinać
  hasMore: boolean;
  // czy zawiera stopkę / podpis, który można zawinąć
  hasFooter: boolean;
}

export const parseHTML = async (
  content: string,
  ig: IImages[],
  fullContent: boolean = true
): Promise<IParsedHtml> => {
  const parser = new DOMParser();

  const doc = parser.parseFromString(content, "text/html");
  //doc.body.style.fontFamily = "Rubik";

  const images = doc.getElementsByTagName("img");
  const links = doc.getElementsByTagName("a");
  const pres = doc.getElementsByTagName("pre");

  for (let i = 0; i < images.length; i++) {
    // Pobierz aktualny obiekt img
    const img = images[i];

    // Sprawdź, czy atrybut src istnieje
    if (img.hasAttribute("src")) {
      // Podmień wartość atrybutu src na nową wartość
      // W poniższym przykładzie zamieniamy każdy src na 'nowa_sciezka.jpg'

      img.getAttribute("src");

      try {
        const url = img
          .getAttribute("src")
          ?.split("/")[3]
          .split("&")[0]
          .replaceAll("image?id=", "");
        const replaceImage = ig.find((i) => i.id === url);
        //

        if (replaceImage) {
          const ie = replaceImage?.content.data;
          const binaryString = Array.from(new Uint8Array(ie), (v) =>
            String.fromCharCode(v)
          ).join("");
          const theImage = btoa(binaryString);

          //@ts-ignore
          img.setAttribute("src", "data:image/png;base64, " + theImage);
        }
      } catch (e) {}
      //   img.setAttribute('alt', 'nowa_sciezka.jpg');
    }
  }

  for (let i = 0; i < links.length; i++) {
    const link = links[i];
    link.setAttribute("target", "_blank");
  }

  for (let i = 0; i < pres.length; i++) {
    const pre = pres[i];
    pre.style.whiteSpace = "break-spaces";
  }

  const elementsToHide = doc.querySelectorAll("#divRplyFwdMsg");

  if (!fullContent) {
    elementsToHide.forEach((el) => {
      const htmlElement = el as HTMLElement;
      if (htmlElement) {
        htmlElement.style.display = "none";
      }
    });
  }

  // Pobierz zmieniony kod HTML
  const modifiedHTML = doc.documentElement.outerHTML;

  return {
    content: modifiedHTML,
    hasMore: elementsToHide.length > 0,
    hasFooter: false,
  };
};
